import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ResendStatementModalContent } from './content';
import { Icon, SimpleModal } from '@livable/saas-react-components';
export default function ResendStatementModal(_ref) {
  let disabled = _ref.disabled,
    residencyId = _ref.residencyId,
    userProfileData = _ref.userProfileData,
    resendStatementId = _ref.resendStatementId,
    resendStatementFileId = _ref.resendStatementFileId,
    variant = _ref.variant;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: variant || 'action',
    'custom-attribute': '812-resident-profile-page-resend-statement-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message"
  }), "Resend");
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: defaultTrigger,
    title: t('resident_account.would_you_like_to_resend'),
    noPadding: true,
    noFooter: true
  }, /*#__PURE__*/React.createElement(ResendStatementModalContent, {
    residencyId: residencyId,
    userProfileData: userProfileData,
    resendStatementId: resendStatementId,
    resendStatementFileId: resendStatementFileId
  }));
}